/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_LinkInputs */

const en_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See every page`)
};

const zh_hans1_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看每个页面`)
};

const pt_br2_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas as páginas`)
};

const es_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas las páginas`)
};

const fr_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir toutes les pages`)
};

const de_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Seiten ansehen`)
};

const ru_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть все страницы`)
};

const it_scrape_router_link = /** @type {(inputs: Scrape_Router_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi tutte le pagine`)
};

/**
* | output |
* | --- |
* | "See every page" |
*
* @param {Scrape_Router_LinkInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_link = /** @type {((inputs?: Scrape_Router_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_LinkInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_link(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_link(inputs)
	if (locale === "es") return es_scrape_router_link(inputs)
	if (locale === "fr") return fr_scrape_router_link(inputs)
	if (locale === "de") return de_scrape_router_link(inputs)
	if (locale === "ru") return ru_scrape_router_link(inputs)
	if (locale === "it") return it_scrape_router_link(inputs)
	return en_scrape_router_link(inputs)
});